import { Injectable, Injector } from '@angular/core';
import { ApplicationType, PeopleApplicationServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CodeService } from '../common/code/code.service';
import { SelectItem } from 'primeng/api';

@Injectable()
export class PeopleApplicationService extends AppComponentBase  {

    peopleApplicationTypes = [
        ApplicationType.Lia, ApplicationType.LiaRen, ApplicationType.Lia90Days,
        ApplicationType.Ehc, ApplicationType.EhcRen, ApplicationType.Ehc90Days,
        ApplicationType.Slap, ApplicationType.SlapRen,
        ApplicationType.Rla, ApplicationType.RlaLim,
        ApplicationType.Alap, ApplicationType.AlapExtr,
        ApplicationType.Abo,
        ApplicationType.Sub,
        ApplicationType.Cogs,
        ApplicationType.Npbo,
        ApplicationType.Ndqr,
        ApplicationType.Ndn,
        ApplicationType.Npf] as const;
    eligibleTypes = [];

    constructor(
        injector: Injector,
        private codeService: CodeService,
        private peopleApplicationServiceProxy: PeopleApplicationServiceProxy
    ) {
        super(injector);
        this.peopleApplicationServiceProxy.getApplicationTypes().subscribe(types => {
            this.eligibleTypes = types;
        });

    }

    getPeopleApplications(filter: string, sorting: string, maxResultCount: number, skipCount: number) {
        return this.peopleApplicationServiceProxy.getPeopleApplications(filter, sorting, maxResultCount, skipCount);
    }

    getProfessions() {
        return this.peopleApplicationServiceProxy.getProfessions();
    }

    getPeopleApplicationTypes() {
        return this.peopleApplicationServiceProxy.getApplicationTypes();
    }
}
